<template>
  <div class="content ht-100v pd-0">
    <div ref="mainHeader" class="content-header bd-b pd-0">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
        <a
          class="navbar-brand tx-spacing--2 order-1"
          data-toggle="dropdown"
          role="button"
        >
          Салбар, Хэлтэс, Нэгж
        </a>
      </nav>
    </div>

    <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
      <div class="container-fluid pd-x-0">
        <div class="row no-gutters">
          <div class="col-xs-2 col-md-2 bg-white">
            <div class="overflow-auto" style="height: calc(100vh - 60px)">
              <Tree
                ref="folterTree"
                node-key="id"
                node-key1="label"
                :data="departs"
                :props="defaultProps"
                @node-click="departChange"
                auto-expand-parent
                highlight-current
                :filter-node-method="filterNode"
                :key="treeKey"
                class="manual-tree"
              >
                <div
                  class="d-flex wd-100p pos-relative"
                  slot-scope="{ node, data }"
                >
                  <div class="pd-r-40">{{ node.label }}</div>
                  <div class="pos-absolute r-5 t-0">
                    <feather
                      @click.stop="() => addSub(data)"
                      class=""
                      type="plus"
                    ></feather>
                    <feather
                      @click.stop="() => deleteSub(data)"
                      class=""
                      type="trash-2"
                    ></feather>
                  </div>
                </div>
              </Tree>
            </div>
          </div>
          <div
            class="col-xs-10 col-md-10 bd-l"
            style="height: calc(100vh - 60px)"
          >
            <div class="content d-flex flex-row align-items-center">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-10 col-sm-6 d-flex flex-column bg-white bd">
                    <form :key="formKey">
                      <div class="form-group row mg-b-0">
                        <label
                          class="col-sm-4 col-form-label d-flex align-items-center"
                          >Парент</label
                        >
                        <div class="col-sm-8">
                          <depart-cascader
                            :checkStrictly="true"
                            :id="locTypeModel.parentId"
                            v-model="locTypeModel.parentId"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0">
                        <label
                          class="col-sm-4 col-form-label d-flex align-items-center"
                          >Хэлтэс алба нэгжийн нэр</label
                        >
                        <div class="col-sm-8">
                          <input
                            v-model="locTypeModel.depart"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0">
                        <label
                          class="col-sm-4 col-form-label d-flex align-items-center"
                          >Товч нэр</label
                        >
                        <div class="col-sm-8">
                          <input
                            v-model="locTypeModel.shortName"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="form-group row  mg-b-0">
                        <label
                          class="col-sm-4 col-form-label d-flex align-items-center"
                          >Дараалал</label
                        >
                        <div class="col-sm-8">
                          <input
                            v-model="locTypeModel.ord"
                            type="number"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <!-- <div class="form-group row mg-b-0 bd-t">
                        <label class="col-sm-4 col-form-label d-flex align-items-center">Удирдах албан тушаалтан</label>
                        <div class="col-sm-8">
                          
                        </div>
                      </div>
                      <div class="form-group row mg-b-0">
                        <label class="col-sm-4 col-form-label d-flex align-items-center">Цаг бүртгэл батлах албан тушаалтан</label>
                        <div class="col-sm-8">
                          
                        </div>
                      </div> -->
                      <div class="form-group row mg-b-0">
                        <div class="col-sm-12">
                          <div v-if="locTypeModel.id > 0" class="btn-group">
                            <button
                              @click="saveData()"
                              type="submit"
                              class="btn btn-success"
                            >
                              Хадгалах
                            </button>
                            <button @click="reset()" class="btn btn-warning">
                              Болих
                            </button>
                          </div>
                          <button
                            @click="saveData()"
                            v-else
                            type="submit"
                            class="btn btn-primary"
                          >
                            Шинэ
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tree } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

var LTT = require("list-to-tree");
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Tree,
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      formKey: 0,
      locTypeModel: {
        id: 0,
        chiefUserId: null,
        timesheetUserId: null
      },
      departsFlat: [],
      departs: [],
      defaultProps: {
        children: "children",
        label: "label",
        iid: "id"
      },
      treeKey: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    reset() {
      this.formKey++;
      this.locTypeModel = {
        id: 0,
        chiefUserId: null,
        timesheetUserId: null
      };
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.departsFlat = res.data.departs;
          var ltt = new LTT(res.data.departs, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children",
            key_ord: "ord"
          });
          this.departs = ltt.GetTree();
          //console.log(this.departs);
        }
      });
    },
    departChange(e) {
      //console.log('departChange fired');
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetInheritedDepart" },
        params: { id: e.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.locTypeModel = res.data.depart;
          this.formKey++;
          //console.log(e);
        }
      });
    },
    addSub(e) {
      //console.log('addSub fired');
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetInheritedDepart" },
        params: { id: 0 },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.locTypeModel = res.data.depart;
          this.locTypeModel.parentId = e.id;
          //this.reset();
          this.formKey++;
        }
      });
    },
    deleteSub(e) {
      if (confirm("Устгахдаа итгэлтэй байна уу ?")) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Hr/DeleteDepart" },
          data: { id: e.id },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.init();
            this.reset();
            this.formKey++;
          }
        });
      }
    },
    saveData() {
      if (this.locTypeModel.id > 0) {
        if (this.locTypeModel.id != this.locTypeModel.parentId) {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "Hr/PostInheritedDepart" },
            data: { model: this.locTypeModel },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.init();
              this.reset();
              this.$bvToast.toast(`Амжилттай`, {
                title: "Мэдэгдэл",
                autoHideDelay: 15000,
                appendToast: true
              });
            }
          });
        } else {
          this.$bvToast.toast(`Парент буруу сонгосон байна !`, {
            title: "Мэдэгдэл",
            autoHideDelay: 15000,
            appendToast: true
          });
        }
      } else {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Hr/PostInheritedDepart" },
          data: { model: this.locTypeModel },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.init();
            this.reset();
            this.$bvToast.toast(`Амжилттай`, {
              title: "Мэдэгдэл",
              autoHideDelay: 15000,
              appendToast: true
            });
          }
        });
      }
    }
  }
};
</script>
